import React, { createContext, useContext, ReactNode } from 'react';

interface SMSUnreadContextType {
  refetchUnreadCount: () => Promise<void>;
}

const SMSUnreadContext = createContext<SMSUnreadContextType | undefined>(undefined);

interface SMSUnreadProviderProps {
  children: ReactNode;
  refetchUnreadCount: () => Promise<void>;
}

export const SMSUnreadProvider: React.FC<SMSUnreadProviderProps> = ({
  children,
  refetchUnreadCount
}) => {
  return (
    <SMSUnreadContext.Provider value={{ refetchUnreadCount }}>
      {children}
    </SMSUnreadContext.Provider>
  );
};

export const useSMSUnreadContext = (): SMSUnreadContextType => {
  const context = useContext(SMSUnreadContext);
  if (!context) {
    throw new Error('useSMSUnreadContext must be used within a SMSUnreadProvider');
  }
  return context;
};

export default SMSUnreadProvider;
